import type { HeaderNavBarLink } from './useHeaderNavbarItems'

export function useCategoryLinks(headerNavbarLinks: ComputedRef<HeaderNavBarLink[] | undefined>) {
  const { submenus } = useHeaderNavbarSubmenus()

  const categoryLinks = computed(() => {
    return headerNavbarLinks.value?.map((link) => {
      const id = link._uid
      const key = `${id}`

      return {
        name: link.text, // Include the name attribute from headerNavbarLinks
        id: link._uid,
        submenus: submenus.value?.[key], // Include the corresponding submenus
      }
    })
  })

  return {
    categoryLinks,
  }
}
